export namespace SPC {
	interface Protocolo {
		numero: number
		numeroSpecified: boolean
		digito: number
		digitoSpecified: boolean
	}

	interface Operador {
		codigo: string
		nome: string
	}

	interface Cpf {
		regiaoorigem: string
		numero: string
	}

	interface Situacaocpf {
		descricaosituacao: string
		datasituacao: Date
		datasituacaoSpecified: boolean
		uf?: any
	}

	interface Estado {
		siglauf: string
	}

	interface Cidade {
		estado: Estado
		nome: string
	}

	interface Endereco {
		cidade: Cidade
		logradouro: string
		numero: string
		complemento: string
		bairro: string
		cep: number
		cepSpecified: boolean
	}

	interface Telefone {
		numeroddd: number
		numerodddSpecified: boolean
		numero: number
		numeroSpecified: boolean
	}

	interface Consumidorpessoafisica {
		cpf: Cpf
		situacaocpf: Situacaocpf
		estadorg?: any
		endereco: Endereco
		telefoneresidencial: Telefone
		telefonecelular: Telefone
		telefonecomercial?: any
		fax?: any
		nacionalidade?: any
		dataexpedicaorgSpecified: boolean
		datanascimento: Date
		datanascimentoSpecified: boolean
		email: string
		estadocivilSpecified: boolean
		idade: number
		idadeSpecified: boolean
		nome: string
		nomemae: string
		nomepai?: any
		nomesocial?: any
		numerorg?: any
		numerotituloeleitor: number
		numerotituloeleitorSpecified: boolean
		pessoaestrangeiraSpecified: boolean
		sexo: number
		sexoSpecified: boolean
		signo: number
		signoSpecified: boolean
	}

	interface Consumidor {
		consumidorpessoafisica: Consumidorpessoafisica
		consumidorpessoajuridica?: any
	}

	interface Grafiapj {
		resumo?: any
		Items?: any
		mensagemalerta?: any
	}

	interface Enderecocepconsultado {
		resumo?: any
		Items?: any
		mensagemalerta?: any
	}

	interface Telefoneconsultado {
		resumo: Resumo
		Items?: any
		mensagemalerta?: any
	}

	interface Telefonevinculadoassinanteconsultado {
		resumo: Resumo
		Items?: any
		mensagemalerta?: any
	}

	interface Ultimotelefoneinformado {
		resumo?: any
		Items?: any
		mensagemalerta?: any
	}

	interface EnderecoItem {
		endereco: Endereco
	}

	interface Ultimoenderecoinformado {
		resumo?: any
		Items: EnderecoItem[]
		mensagemalerta?: any
	}

	interface Alertadocumento {
		resumo: Resumo
		Items?: any
		mensagemalerta?: any
	}

	interface SpcItem {
		cidadeassociado: Cidade
		telefoneassociado: Telefone
		nomeassociado: string
		codigoentidadeSpecified: boolean
		contacontrato?: any
		datainclusao: Date
		datainclusaoSpecified: boolean
		datavencimento: Date
		datavencimentoSpecified: boolean
		reservado?: any
		nomeentidade: string
		contrato: string
		registroinstituicaofinanceiraSpecified: boolean
		registrorelevanteSpecified: boolean
		compradorfiadoravalista: string
		valor: number
		valorSpecified: boolean
		registroinstituicaofinanceira?: number
	}

	interface Spc {
		resumo: Resumo
		Items: SpcItem[]
		mensagemalerta?: any
	}

	interface SPCItemResult {
		datafinalperiodoconsultadoSpecified: boolean
		datainicialperiodoconsultadoSpecified: boolean
		resumo: Resumo
		Items?: any
		mensagemalerta?: any
	}

	interface Origemassociado {
		estado: Estado
		nome: string
	}

	interface ConsultarealizadaItem {
		origemassociado: Origemassociado
		nomeassociado: string
		dataconsulta: Date
		dataconsultaSpecified: boolean
		nomeentidadeorigem: string
	}

	interface Consultarealizada {
		quantidadediasconsultados: number
		quantidadediasconsultadosSpecified: boolean
		resumo: Resumo
		Items: ConsultarealizadaItem[]
		mensagemalerta?: any
	}

	interface Informacaopoderjudiciario {
		resumo: Resumo
		Items?: any
		mensagemalerta?: any
	}

	interface Moeda {
		simbolo: string
	}

	interface PendenciaFinanceiraItem {
		moeda: Moeda
		naturezaanotacao?: any
		subjudice?: any
		cidade: Cidade
		avalista: boolean
		avalistaSpecified: boolean
		contrato: string
		dataocorrencia: Date
		dataocorrenciaSpecified: boolean
		filial?: any
		indicadorsubjudiceSpecified: boolean
		origem: string
		tituloocorrencia: string
		valorpendencia: number
		valorpendenciaSpecified: boolean
	}

	interface Pendenciafinanceira {
		resumo: Resumo
		Items: PendenciaFinanceiraItem[]
		mensagemalerta?: any
	}

	interface Chequesemfundovarejo {
		resumo: Resumo
		Items?: any
		mensagemalerta?: any
	}

	interface Chequeconsultaonlinesrs {
		resumo: Resumo
		Items?: any
		mensagemalerta?: any
	}

	interface Resumo {
		quantidadetotal: number
		quantidadetotalSpecified: boolean
		mesanoprimeiraocorrencia?: any
		mesanoultimaocorrencia?: any
		dataprimeiraocorrenciaSpecified: boolean
		dataultimaocorrencia: Date
		dataultimaocorrenciaSpecified: boolean
		valortotal: number
		valortotalSpecified: boolean
		valorultimaocorrenciaSpecified: boolean
	}

	export interface ConsultaSimples {
		protocolo: Protocolo
		operador: Operador
		mensagembaseexterna?: any
		baseinoperante?: any
		consumidor: Consumidor
		grafiapj: Grafiapj
		enderecocepconsultado: Enderecocepconsultado
		telefoneconsultado: Telefoneconsultado
		telefonevinculadoconsumidor?: any
		telefonevinculadoassinanteconsultado: Telefonevinculadoassinanteconsultado
		ultimotelefoneinformado: Ultimotelefoneinformado
		ultimoenderecoinformado: Ultimoenderecoinformado
		participacaoempresa?: any
		socio?: any
		administrador?: any
		alertadocumento: Alertadocumento
		spc: Spc
		chequelojista: SPCItemResult
		ccf: SPCItemResult
		contraordemdocumentodiferente: SPCItemResult
		contraordemagenciadiferente?: SPCItemResult
		contraordemagenciacontadiferente?: SPCItemResult
		acao?: SPCItemResult
		protesto: SPCItemResult
		contraordem: SPCItemResult
		contumacia: SPCItemResult
		creditoconcedido: SPCItemResult
		bancoagenciacontadocumentodiferente?: any
		dadosagenciabancaria: SPCItemResult
		consultarealizada: Consultarealizada
		informacaopoderjudiciario: Informacaopoderjudiciario
		riskscoring6meses?: any
		riskscoring12meses?: any
		chequesemfundoachei?: any
		chequesemfundoacheiccf?: any
		contumaciasrs?: any
		participacaofalencia?: any
		restricaofinanceira?: any
		pendenciafinanceira: Pendenciafinanceira
		chequesemfundovarejo: Chequesemfundovarejo
		contraordemsrs?: any
		contraordemdocumentodiferentesrs?: any
		chequeoutrasocorrenciassrs?: any
		chequeconsultaonlinesrs: Chequeconsultaonlinesrs
		consultarealizadacheque?: any
		referenciaisnegociosporfaixa?: any
		historicopagamentoporfaixa?: any
		relacionamentomaisantigocomfornecedores?: any
		registroconsulta?: any
		ultimasconsultas?: any
		capitalsocial?: any
		antecessora?: any
		atividadeempresa?: any
		filial?: any
		informacoesadicionais?: any
		incorporacaofusaocisao?: any
		principaisprodutos?: any
		mensagemcomplementar?: any
		spcscore3meses?: any
		spcscore12meses?: any
		spcobito?: any
		confirmacaorg?: any
		renavamfederal?: any
		roubofurto?: any
		dpvat?: any
		gravame?: any
		renavamestadual?: any
		localizaVeiculo?: any
		rendapresumidaspc?: any
		limitecreditosugerido?: any
		ocupacao?: any
		informacoescomplementares?: any
		telefonealternativo?: any
		alertaobito?: SPCItemResult
		alertaidentidade?: any
		faturamentopresumido?: any
		limitecreditopj?: any
		gastoestimadopj?: any
		quadrosocialmaiscompletopj?: any
		riscocreditopj?: any
		perfilfinanceiropj?: any
		gastoestimadopf?: any
		indicerelacionamentomercadopf?: any
		indicerelacionamentomercadopj?: any
		limitecreditosugeridosar?: any
		comprometimentorendamensalpf?: any
		collectionscoreplus?: any
		biometriafacial?: any
		decodificadorveiculo?: any
		precificadorveiculo?: any
		rodaspneusveiculo?: any
		restricaoestadualveiculo?: any
		debitoestadualveiculo?: any
		indiciosinistroveiculo?: any
		leilaoveiculo?: any
		historicokmveiculo?: any
		historicoavariasveiculo?: any
		basenacionalveiculo?: any
		restricaonacionalveiculo?: any
		roubofurtoveiculo?: any
		recallveiculo?: any
		parecertecnicoveiculo?: any
		gravameveiculo?: any
		scorecadastropositivo?: any
		indicepontualidadepagamentocadastropositivo?: any
		indicecomportamentogastoscadastropositivo?: any
		movimentacaocadastropositivo?: any
		historicopagamentocadastropositivo?: any
		indiceconsultarealizadaporsegmentocadastropositivo?: any
		scorepj?: any
		scoreempresas6meses?: any
		scoreempresas12meses?: any
		perfilcomportamental?: any
		restricao: boolean
		restricaoSpecified: boolean
		data: Date
		dataSpecified: boolean
	}

	interface Cnpjconsultado {
		numero: string
	}

	interface Cpfconsultado {
		regiaoorigem: string
		numero: string
	}

	interface Spcscore12meses {
		classe: string
		horizonte: number
		mesageminterpretativascore: string
		mesageminterpretativaprobabilidade?: any
		mesagemsemaforo?: any
		probabilidadeSpecified: boolean
		score: number
		segmentoscore?: any
		tipoclientescore: number
		tipoclientescoreSpecified: boolean
	}

	interface Spcscore3meses {
		classe: string
		horizonte: number
		mesageminterpretativascore: string
		mesageminterpretativaprobabilidade?: any
		mesagemsemaforo?: any
		probabilidadeSpecified: boolean
		score: number
		segmentoscore?: any
		tipoclientescore: number
		tipoclientescoreSpecified: boolean
	}

	export interface ConsultaScore {
		cnpjconsultado: Cnpjconsultado
		cpfconsultado: Cpfconsultado
		spcscore12meses: Spcscore12meses
		spcscore3meses: Spcscore3meses
	}

	export interface ISPC {
		consultaSimples: ConsultaSimples
		consultaScore: ConsultaScore
	}

	export class SPC {
		private _consultaSimples: ConsultaSimples
		private _consultaScore: ConsultaScore

		Score: number

		constructor(inputSpc: ISPC) {
			this._consultaScore = inputSpc.consultaScore
			this._consultaSimples = inputSpc.consultaSimples

			this.Score = this._consultaScore.spcscore12meses.score
		}

		getQtdAcao(): number {
			try {
				if (this._consultaSimples.acao) return this._consultaSimples.acao.resumo.quantidadetotal

				return 0
			} catch {
				return 0
			}
		}

		getValorTotalAcao(): number {
			try {
				if (this._consultaSimples.acao) return this._consultaSimples.acao.resumo.valortotal
				return 0
			} catch {
				return 0
			}
		}

		getUltimaOcorrenciaAcao(): string {
			try {
				if (this._consultaSimples.acao) {
					var date = new Date(this._consultaSimples.acao.resumo.dataultimaocorrencia)
					return date.toLocaleDateString('pt-BR')
				}

				return '-'
			} catch {
				return '-'
			}
		}

		getQtdProtesto(): number {
			try {
				return this._consultaSimples.protesto.resumo.quantidadetotal
			} catch {
				return 0
			}
		}

		getValorTotalProtesto(): number {
			try {
				if (this._consultaSimples.protesto.resumo.valortotal) return this._consultaSimples.protesto.resumo.valortotal

				return 0
			} catch {
				return 0
			}
		}

		getUltimaOcorrenciaProtesto(): string {
			try {
				if (this._consultaSimples.protesto.resumo.dataultimaocorrencia) {
					var date = new Date(this._consultaSimples.protesto.resumo.dataultimaocorrencia)
					return date.toLocaleDateString('pt-BR')
				}

				return '-'
			} catch {
				return '-'
			}
		}

		getQtdAlertaObito(): number {
			try {
				if (this._consultaSimples.alertaobito) return this._consultaSimples.alertaobito.resumo.quantidadetotal
				return 0
			} catch {
				return 0
			}
		}

		getValorTotalAlertaObito(): number {
			try {
				if (this._consultaSimples.alertaobito) return this._consultaSimples.alertaobito.resumo.valortotal

				return 0
			} catch {
				return 0
			}
		}

		getUltimaOcorrenciaAlertaObito() {
			try {
				if (this._consultaSimples.alertaobito) {
					var date = new Date(this._consultaSimples.alertaobito.resumo.dataultimaocorrencia)
					return date.toLocaleDateString('pt-BR')
				}

				return '-'
			} catch {
				return '-'
			}
		}

		getQtdConsultaRealizada() {
			try {
				if (this._consultaSimples.consultarealizada) return this._consultaSimples.consultarealizada.resumo.quantidadetotal

				return 0
			} catch {
				return 0
			}
		}

		getValorTotalConsultaRealizada() {
			try {
				if (this._consultaSimples.consultarealizada) return parseInt(this._consultaSimples.consultarealizada.resumo.valortotal.toString())

				return 0
			} catch {
				return 0
			}
		}

		getUltimaOcorrenciaConsultaRealizada() {
			try {
				if (this._consultaSimples.consultarealizada) {
					var date = new Date(this._consultaSimples.consultarealizada.resumo.dataultimaocorrencia)
					if (!isNaN(date.getTime())) return date.toLocaleDateString('pt-BR')
				}

				return '-'
			} catch {
				return '-'
			}
		}

		getQtdRegistroSPC() {
			try {
				return this._consultaSimples.spc.resumo.quantidadetotal
			} catch {
				return 0
			}
		}

		getValorTotalRegistroSPC() {
			try {
				if (this._consultaSimples.spc.resumo.valortotal) return this._consultaSimples.spc.resumo.valortotal

				return 0
			} catch {
				return 0
			}
		}

		getUltimaOcorrenciaRegistroSPC() {
			try {
				if (this._consultaSimples.spc.resumo.dataultimaocorrencia) {
					var date = new Date(this._consultaSimples.spc.resumo.dataultimaocorrencia)
					return date.toLocaleDateString('pt-BR')
				}

				return '-'
			} catch {
				return '-'
			}
		}

		getQtdInformacaoJudiciario() {
			try {
				return this._consultaSimples.informacaopoderjudiciario.resumo.quantidadetotal
			} catch {
				return 0
			}
		}

		getValorTotalInformacaoJudiciario() {
			try {
				if (this._consultaSimples.informacaopoderjudiciario.resumo.valortotal)
					return this._consultaSimples.informacaopoderjudiciario.resumo.valortotal

				return 0
			} catch {
				return 0
			}
		}

		getUltimaOcorrenciaInformacaoJudiciario() {
			try {
				if (this._consultaSimples.informacaopoderjudiciario.resumo.dataultimaocorrencia) {
					var date = new Date(this._consultaSimples.informacaopoderjudiciario.resumo.dataultimaocorrencia)
					return date.toLocaleDateString('pt-BR')
				}

				return '-'
			} catch {
				return '-'
			}
		}

		getQtdChequeSemFundoVarejo() {
			try {
				return this._consultaSimples.chequesemfundovarejo.resumo.quantidadetotal
			} catch {
				return 0
			}
		}

		getValorTotalChequeSemFundoVarejo() {
			try {
				if (this._consultaSimples.chequesemfundovarejo.resumo.valortotal)
					return this._consultaSimples.chequesemfundovarejo.resumo.valortotal

				return 0
			} catch {
				return 0
			}
		}

		getUltimaOcorrenciaChequeSemFundoVarejo() {
			try {
				if (this._consultaSimples.chequesemfundovarejo.resumo.dataultimaocorrencia) {
					var date = new Date(this._consultaSimples.chequesemfundovarejo.resumo.dataultimaocorrencia)
					return date.toLocaleDateString('pt-BR')
				}

				return '-'
			} catch {
				return '-'
			}
		}

		getQtdChequeSemFundoCCF() {
			try {
				return this._consultaSimples.ccf.resumo.quantidadetotal
			} catch {
				return 0
			}
		}

		getValorTotalChequeSemFundoCCF() {
			try {
				if (this._consultaSimples.ccf.resumo.valortotal) return this._consultaSimples.ccf.resumo.valortotal

				return 0
			} catch {
				return 0
			}
		}

		getUltimaOcorrenciaChequeSemFundoCCF() {
			try {
				if (this._consultaSimples.ccf.resumo.dataultimaocorrencia) {
					var date = new Date(this._consultaSimples.ccf.resumo.dataultimaocorrencia)
					return date.toLocaleDateString('pt-BR')
				}

				return '-'
			} catch {
				return '-'
			}
		}

		getQtdChequeLojista() {
			try {
				return this._consultaSimples.chequelojista.resumo.quantidadetotal
			} catch {
				return 0
			}
		}

		getValorTotalChequeLojista() {
			try {
				if (this._consultaSimples.chequelojista.resumo.valortotal) return this._consultaSimples.chequelojista.resumo.valortotal

				return 0
			} catch {
				return 0
			}
		}

		getUltimaOcorrenciaChequeLojista() {
			try {
				if (this._consultaSimples.chequelojista.resumo.dataultimaocorrencia) {
					var date = new Date(this._consultaSimples.chequelojista.resumo.dataultimaocorrencia)
					return date.toLocaleDateString('pt-BR')
				}

				return '-'
			} catch {
				return '-'
			}
		}

		getQtdContraOrdem() {
			try {
				return this._consultaSimples.contraordem.resumo.quantidadetotal
			} catch {
				return 0
			}
		}

		getValorTotalContraOrdem() {
			try {
				if (this._consultaSimples.contraordem.resumo.valortotal) return this._consultaSimples.contraordem.resumo.valortotal

				return 0
			} catch {
				return 0
			}
		}

		getUltimaOcorrenciaContraOrdem() {
			try {
				if (this._consultaSimples.contraordem.resumo.dataultimaocorrencia) {
					var date = new Date(this._consultaSimples.contraordem.resumo.dataultimaocorrencia)
					return date.toLocaleDateString('pt-BR')
				}

				return '-'
			} catch {
				return '-'
			}
		}

		getQtdParticipacaoEmpresa() {
			try {
				return parseInt(this._consultaSimples.participacaoempresa.resumo.quantidadetotal)
			} catch {
				return 0
			}
		}

		getValorTotalParticipacaoEmpresa() {
			try {
				if (this._consultaSimples.participacaoempresa.resumo.valortotal) return this._consultaSimples.participacaoempresa.resumo.valortotal

				return 0
			} catch {
				return 0
			}
		}

		getUltimaOcorrenciaParticipacaoEmpresa() {
			try {
				if (this._consultaSimples.participacaoempresa.resumo.dataultimaocorrencia) {
					var date = new Date(this._consultaSimples.participacaoempresa.resumo.dataultimaocorrencia)
					return date.toLocaleDateString('pt-BR')
				}

				return '-'
			} catch {
				return '-'
			}
		}
	}
}
